export default __webpack_public_path__ + "static/media/english.32b43a09.webp";